/*export const config = {
	api_url: "http://localhost:9500"	
}*/

export const config = {
	api_url: "https://coachmeapi.manuellamaya.com"
};